import { memo } from 'react';
import styled from "styled-components";

const Button = ({
  id = "prime-btn-id",
  variant = 'primary',
  onClick = () => {},
  size = 'md',
  disabled = false,
  style,
  children,
  ...props
}) => {

  if(variant === "link" || variant === "link-danger") {
    return (
      <Link 
        id={id}
        onClick={onClick}
        style={style}
        variant={variant}
        disabled={disabled}>
        {children}
      </Link>
    )
  }
  return (
    <Container 
      {...props}
      id={id}
      onClick={onClick}
      style={style}
      disabled={disabled}
      variant={variant}
      size={size}>
      {children}
    </Container>
  );
};

const getCursor = (disabled) => {
  if(disabled) return "not-allowed";
  return "pointer";
}

const getSize = (size) => {
  switch(size) {
    case "sm": return '7px 18px';
    case "lg": return '16px 36px';
    default: return '12px 16px';
  }
}

const getBackgroundColor = (variant, disabled) => {
  if(disabled) {
    return "#c6c6c6";
  }

  switch(variant) {
    case "primary": return "#0F62FE";
    case "outlined": return "#fff";
    case "danger": return "#DA1E28";
    case "success": return "#24A148";
    case "success-outlined": return "#fff";
    case "danger-outlined": return "#fff";
    default: return "#0F62FE";
  }
}

const getBorder = (variant, disabled) => {
  if(disabled) {
    return "#c6c6c6";
  }

  switch(variant) {
    case "primary": return "#0F62FE";
    case "outlined": return "#0F62FE";
    case "success": return "#24A148";
    case "danger": return "#DA1E28";
    case "success-outlined": return "#24A148";
    case "danger-outlined": return "#DA1E28";
    default: return "#0F62FE";
  }
}

const getBackgroundColorHover = (variant, disabled) => {
  if(disabled) {
    return "#c6c6c6"
  }
  switch(variant) {
    case "primary": return "#0152ea";
    case "outlined": return "#0152ea";
    case "danger": return "#bc1a23";
    case "danger-outlined": return "#bc1a23";
    case "success": return "#1e853c";
    case "success-outlined": return "#1e853c";
    default: return "#0152ea";
  }
}

const getColor = (variant, disabled) => {
  if(disabled) {
    return "#8D8D8D"
  }
  switch(variant) {
    case "primary": return "#fff";
    case "outlined": return "#0F62FE";
    case "danger": return "#fff";
    case "danger-outlined": return "#DA1E28";
    case "success": return "#fff";
    case "success-outlined": return "#24A148";
    default: return "#0F62FE";
  }
}

const getColorOnHover = (disabled) => {
  if(disabled) return "#8D8D8D"
  return "#fff";
}

const getLinkColor = (variant, disabled) => {
  if(disabled) return "#8D8D8D";

  switch(variant) {
    case "link-danger": return "#DA1E28";
    default: return "#0F62FE";
  }
}

const getLinkColorHover = (variant, disabled) => {
  if(disabled) return "#8D8D8D";

  switch(variant) {
    case "link-danger": return "#bc1a23";
    default: return "#0152ea";
  }
}

const Container = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => getBackgroundColor(props.variant, props.disabled)};
  border: 1px solid ${props => getBorder(props.variant, props.disabled)};
  border-radius: 3px;
  padding: ${props => getSize(props.size)};
  color: ${props => getColor(props.variant, props.disabled)};
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.16px;
  cursor: ${props => getCursor(props.disabled)};
  transition: all .3s;
  outline: none;

  &:hover {
    background-color: ${props => getBackgroundColorHover(props.variant, props.disabled)};
    border: 1px solid ${props => getBorder(props.variant, props.disabled)};
    color: ${props => getColorOnHover(props.disabled)};;
  }
`

const Link = styled.span`
  cursor: ${props => getCursor(props.disabled)};
  color: ${props => getLinkColor(props.variant, props.disabled)};
  transition: all .3s;

  &:hover {
    color: ${props => getLinkColorHover(props.variant, props.disabled)};
  }
`


export default memo(Button);